import { createFileRoute } from '@tanstack/react-router'
import { WithdrawalsPage } from '@/features/finance/withdrawals/pages/withdrawals-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/withdrawals/')({
  component: WithdrawalsPage,
  beforeLoad: requireRole(['admin']),
})

